import React from 'react';
export function Logo({
  className = ''
}: {
  className?: string;
}) {
  return <span className={`flex items-center gap-2.5 ${className}`} data-id="element-152" data-mp="8ste5uwzn7jk">
      <span className="relative flex h-7 w-7 items-center justify-center rounded-md bg-brand" data-id="element-153" data-mp="8ue9vnv1gwj0">
        <span className="h-2.5 w-2.5 rounded-[3px] bg-black" data-id="element-154" data-mp="3qbeaelr8a0y2" />
      </span>
      <span className="text-[17px] font-extrabold tracking-tightest text-white" data-id="element-155" data-mp="3v9pgcleejrb0">
        BYBIT
        <span className="ml-1.5 align-middle text-[9px] font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-156" data-mp="mtw3qhn6yzz8">
          referido
        </span>
      </span>
    </span>;
}